import {Cookie} from './cookie';

export class AppInstall {

    constructor() {
        let deferredPrompt = null;
        let cookie = new Cookie();
        let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (window.innerWidth < 992) {
            if (isIOS) {
                $('.c-app-popup__ios').css('display', 'flex');
            } else {
                $('.c-app-popup__android').css('display', 'flex');
            }
            if (typeof window.onbeforeinstallprompt !== 'undefined') {
                window.addEventListener('beforeinstallprompt', (e) => {
                    if (!cookie.has('hideAppInstallPopup')) {
                        // Prevent the mini-infobar from appearing on mobile
                        e.preventDefault();
                        // Stash the event so it can be triggered later.
                        deferredPrompt = e;
                        // Update UI notify the user they can install the PWA
                        $('#appInstallModal').modal('show');
                    }
                });
            } else {
                if (!cookie.has('hideAppInstallPopup')) {
                    $('#appInstallModal').modal('show');
                }
            }
        }

        $('#appInstallModal').on('hidden.bs.modal', function (e) {
            // Set cookie to hide popup
            cookie.set('hideAppInstallPopup', true, 365 * 5);
            if (typeof window.onbeforeinstallprompt !== 'undefined') {
                // Show the install prompt
                deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt');
                    } else {
                        console.log('User dismissed the install prompt');
                    }
                });
            }
        })
    }

}
